import { Col, Modal, Row, Form, Input } from 'antd';
import * as React from 'react';
import { Provider } from 'unstated';

import { StateContainer } from './StateContainer';

interface ISupplierDetailProps {
    supplier: GQL.ISupplier;
    onSave: (supplier: GQL.ISupplier) => void;
    onCancel: () => void;
}

export default class SupplierDetail extends React.Component<ISupplierDetailProps> {
    private supplierContainer: StateContainer;

    public constructor(props: ISupplierDetailProps) {
        super(props);
        this.supplierContainer = new StateContainer({
            supplier: props.supplier
        });

        this.save = this.save.bind(this);
    }

    public render() {
        const { supplier } = this.supplierContainer.state;

        return (
            <Provider>
                <Modal
                    // maskClosable={false}
                    style={{ top: '5vh' }}
                    width={'50%'}
                    bodyStyle={{ minHeight: '80vh' }}
                    title={`Supplier ${supplier && supplier.name}`}
                    visible={true}
                    cancelText={'Close'}
                    okText={'Save changes'}
                    onOk={this.save}
                    onCancel={() => this.props.onCancel()}
                >
                    <Row>
                        <Col span={24}>
                            <Form>
                                <Form.Item
                                    validateStatus={this.supplierContainer.state.errors.name ? 'error' : undefined}
                                    help={this.supplierContainer.state.errors.name}
                                >
                                    <Input
                                        autoFocus={true}
                                        name={'name'}
                                        placeholder="Supplier's name"
                                        defaultValue={supplier.name}
                                        onChange={e => this.onChange('name', e.target.value)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Modal>
            </Provider>
        );
    }
    private onChange(key: string, val: any) {
        this.supplierContainer.onChange(key, val);
    }

    private async save() {
        const errors = await this.supplierContainer.validate(); // TODO
        let anyError = false;

        for (const key of Object.keys(errors)) {
            if (errors[key] != undefined) {
                anyError = true;
            }
        }

        if (!anyError) {
            this.props.onSave(this.supplierContainer.state.supplier);
        } else {
            console.log('there is error, can not save', errors);
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Suppliers/SupplierDetail/SupplierDetail.tsx